<template>
  <v-container>
    <div id="write" class="is-mac">
      <h1><a name="header-c5" class="md-header-anchor "></a>录谱规范</h1>
      <h2><a name="header-c7" class="md-header-anchor "></a>一、注意事项</h2>
      <h3>
        <a name="header-c8" class="md-header-anchor "></a>1.录谱系统：Musescore3
      </h3>
      <p>
        Musescore下载网址：<a href="https://musescore.org/zh-hans/download"
          >https://musescore.org/zh-hans/download</a
        >
      </p>
      <h3>
        <a name="header-c11" class="md-header-anchor "></a>2.
        书中一首曲子，就对应一个乐谱
      </h3>
      <p>按照曲子来划分：一首曲子，在系统里就是一个谱子。</p>
      <h3>
        <a name="header-c14" class="md-header-anchor "></a>3.
        书上印刷有多行谱表的曲子
      </h3>
      <p>
        <img
          src="https://uploader.shimo.im/f/cSYM0Z3ovHI8Ix7T.jpeg!thumbnail"
          alt="图片"
        /><img
          src="https://uploader.shimo.im/f/95LGYzOgziYx6WPV.jpeg!thumbnail"
          alt="图片"
        />
      </p>
      <p>
        如若一首曲子有多声部或多行谱表，需要将每个声部分成单独的乐谱分别录入。（双谱分谱：点左上角“文件”→“分谱...”→“新建所有”→“OK”）
      </p>
      <h3>
        <a name="header-c19" class="md-header-anchor "></a>4.
        音符记号不能拖拽位置
      </h3>
      <p>
        所有的记号不能手动拖拽，导出的 musicxml
        文件会自动归位，以展示效果为准，判断是否可行。
      </p>
      <h3>
        <a name="header-c22" class="md-header-anchor "></a>5.
        录完之后要自己检查一下
      </h3>
      <p>
        录完一首曲子，上传到创作中心后。建议在上传的声部预览里检查一下谱子是否有错误。
      </p>
      <h2><a name="header-c25" class="md-header-anchor "></a>二、乐谱详情</h2>
      <h3><a name="header-c26" class="md-header-anchor "></a>6. 标题</h3>
      <p>1、录入主标题；</p>
      <p>2、副标题可以不录入；</p>
      <p>3、标题字体字体为 FreeSerif，大小为 36 号（推荐）；</p>
      <p>4、标题太长可以适当缩小字体；</p>
      <p>5、标题里的标点须区分语言，如区分中文括号（）和英文括号用 ()；</p>
      <p>
        <img
          src="https://uploader.shimo.im/f/J1YHsYE4UbsanoXz.jpeg!thumbnail"
          alt="图片"
        /><img
          src="https://uploader.shimo.im/f/GR6IRoTCtVsWPTjl.jpeg!thumbnail"
          alt="图片"
        />
      </p>
      <h3><a name="header-c39" class="md-header-anchor "></a>7. 作曲家</h3>
      <p>
        有作曲家的直接写作曲家的名字，没有作曲家时，系统上传填佚名。（音阶练习的作曲家就填“音阶”），字体为
        FreeSerif，字号为 12 号（推荐）。
      </p>
      <h3><a name="header-c42" class="md-header-anchor "></a>8. 调号/谱号</h3>
      <p>注意在更改谱号/调号时，音高可能会发生变化。</p>
      <p>
        <img
          src="https://uploader.shimo.im/f/Q9lcFZ9fyM0gccoW.jpeg!thumbnail"
          alt="图片"
        />
      </p>
      <p>
        <img
          src="https://uploader.shimo.im/f/BeRP9skSHwE4JzMU.jpeg!thumbnail"
          alt="图片"
        />
      </p>
      <h3><a name="header-c49" class="md-header-anchor "></a>9. 节拍</h3>
      <p>乐谱的节拍需与原谱一致。</p>
      <p>
        <img
          src="https://uploader.shimo.im/f/8LI4r9H986MBNWQS.jpeg!thumbnail"
          alt="图片"
        />
      </p>
      <h3>
        <a name="header-c54" class="md-header-anchor "></a>10.
        速度：乐谱有明确的速度值
      </h3>
      <p>1、每首曲子都需有速度，如原谱没有标明，可根据拍号参考：</p>
      <p>二拍子（2/2拍）：二分音符=50~60；</p>
      <p>四拍子（2/4拍，3/4拍，4/4拍）：♩=70~80；</p>
      <p>八拍子（3/8拍，5/8拍，6/8拍，7/8拍）：♪≥120</p>
      <p>
        <img
          src="https://uploader.shimo.im/f/7uFwceJunks850BH.jpeg!thumbnail"
          alt="图片"
        />
      </p>
      <h3><a name="header-c65" class="md-header-anchor "></a>11. 音高</h3>
      <p>
        <img
          src="https://uploader.shimo.im/f/jEb6zMVMyhYsjaol.jpeg!thumbnail"
          alt="图片"
        /><img
          src="https://uploader.shimo.im/f/uCJiR8g2mk4LjLGl.jpeg!thumbnail"
          alt="图片"
        />
      </p>
      <h3><a name="header-c68" class="md-header-anchor "></a>12. 临时升降号</h3>
      <p>修改临时升降号时，注意其他音的是否多出临时升降号。</p>
      <p>
        <img
          src="https://uploader.shimo.im/f/b45zlZOL8GoGvWv1.jpeg!thumbnail"
          alt="图片"
        />
      </p>
      <h3><a name="header-c73" class="md-header-anchor "></a>13. 力度记号</h3>
      <p>确保力度记号位置的正确性。</p>
      <p>
        <img
          src="https://uploader.shimo.im/f/vkLrxbUE48Acf5ZJ.jpeg!thumbnail"
          alt="图片"
        />
      </p>
      <h3><a name="header-c78" class="md-header-anchor "></a>14. 线段</h3>
      <p>
        <img
          src="https://uploader.shimo.im/f/F5aVmNDeG0kQYtmR.jpeg!thumbnail"
          alt="图片"
        /><img
          src="https://uploader.shimo.im/f/VGrmh6it5j03EaJ9.jpeg!thumbnail"
          alt="图片"
        />
      </p>
      <p>
        遇到音符下方有线的统一用【线段】，其他效果无法正常展示。线段首段可加文字，末端文字无法正常展示，如需添加请使用谱表文字或指法。
      </p>
      <h3><a name="header-c83" class="md-header-anchor "></a>15. 连音线</h3>
      <p>相同音高的用“延音线”，不同音高的用“连句线”</p>
      <p>
        <img
          src="https://uploader.shimo.im/f/6UZ7g8YIrooQR9ES.jpeg!thumbnail"
          alt="图片"
        /><img
          src="https://uploader.shimo.im/f/4NGKmTrKaXwahYhe.jpeg!thumbnail"
          alt="图片"
        />
      </p>
      <h3><a name="header-c88" class="md-header-anchor "></a>16. 倚音</h3>
      <p>
        <img
          src="https://uploader.shimo.im/f/vY23zkl37z0Bnx5Y.jpeg!thumbnail"
          alt="图片"
        /><img
          src="https://uploader.shimo.im/f/tv32qDCnuU4HuAr2.jpeg!thumbnail"
          alt="图片"
        />
      </p>
      <p>1、倚音与主音的连接须使用连句线（即连音线）；</p>
      <p>2、录入时，按住 Ctrl，选择倚音和主音的符头，再双击连句线；</p>
      <p>3、倚音内部不能有连句线</p>
      <h3>
        <a name="header-c97" class="md-header-anchor "></a>17. 渐强渐弱线条
      </h3>
      <p>1、录入时，点击起点，按住Ctrl，再点击终点（不要拖拽）</p>
      <p>2、点击多次，会有重复现象，注意无需重复录入</p>
      <p>3、有多声部时，录入到第1个声部（蓝色）</p>
      <p>
        <img
          src="https://uploader.shimo.im/f/neFuJUeLER85alSV.jpeg!thumbnail"
          alt="图片"
        />
      </p>
      <h3><a name="header-c106" class="md-header-anchor "></a>18. 指法</h3>
      <p>1、指法必须用 MuseScore 里面的数字指法</p>
      <p>
        2、如果某些指法带有文字或者括号，就要用谱表文字来录制。（否则可能导致乐谱无法完整显示）
      </p>
      <p>
        <img
          src="https://uploader.shimo.im/f/SwHizL7kof0mDewV.jpeg!thumbnail"
          alt="图片"
        />
      </p>
      <h3><a name="header-c113" class="md-header-anchor "></a>19. 文字</h3>
      <p>1、乐谱中的文字都用谱表文字来录制</p>
      <p>2、一些描述性的文字，可以直接用谱表文本的方式录入</p>
      <p>
        <img
          src="https://uploader.shimo.im/f/SwHizL7kof0mDewV.jpeg!thumbnail"
          alt="图片"
        />
      </p>
      <h3>
        <a name="header-c120" class="md-header-anchor "></a>20. cresc. 和 dim.
      </h3>
      <p>直接录谱表文字，不要使用线条记号</p>
      <p>
        <img
          src="https://uploader.shimo.im/f/SwHizL7kof0mDewV.jpeg!thumbnail"
          alt="图片"
        />
      </p>
      <h3><a name="header-c125" class="md-header-anchor "></a>21. 谱表文字</h3>
      <p>谱表文字： ctrl+T就会出现文本框，打出的字就是谱表文字</p>
      <p>
        <img
          src="https://uploader.shimo.im/f/SwHizL7kof0mDewV.jpeg!thumbnail"
          alt="图片"
        />
      </p>
      <h3><a name="header-c130" class="md-header-anchor "></a>22. 多声部</h3>
      <p>1、第1个声部（蓝色）默认在上面、第2个声部（绿色）在下面</p>
      <p>
        <img
          src="https://uploader.shimo.im/f/h2DunseWBCgHh6Mm.jpeg!thumbnail"
          alt="图片"
        />
      </p>
      <h3>
        <a name="header-c135" class="md-header-anchor "></a>23. 重复跳转记号
      </h3>
      <p>
        <img
          src="https://uploader.shimo.im/f/Nz19i3IwrWQCQpHk.jpeg!thumbnail"
          alt="图片"
        />
      </p>
      <p>1、使用MuseScore里面的跳转记号，不可以录入成文字；</p>
      <p>2、跳转记号的位置不能拖拽，要通过点选的方式录入</p>
      <h3>
        <a name="header-c142" class="md-header-anchor "></a>24. 奏点与持续音记号
      </h3>
      <p>遇到奏点和持续音记号时，奏点相比持续音要靠近音符。</p>
      <p>
        <img
          src="https://uploader.shimo.im/f/hq04u1DMDL8iUyRF.jpeg!thumbnail"
          alt="图片"
        />
      </p>
      <h3><a name="header-c147" class="md-header-anchor "></a>25. 八度记号</h3>
      <p>1、起点和终点位置须精确；</p>
      <p>2、选择起始点、按住Shift、再选择终点录入（不可拖拽）；</p>
      <p>
        <img
          src="https://uploader.shimo.im/f/2chCMfQaBwQK6dRT.jpeg!thumbnail"
          alt="图片"
        />
      </p>
      <h3><a name="header-c154" class="md-header-anchor "></a>26. 颤音</h3>
      <p>
        <img
          src="https://uploader.shimo.im/f/8HFWnrx0dfc7LAac.jpeg!thumbnail"
          alt="图片"
        /><img
          src="https://uploader.shimo.im/f/ou7UWbgdgXAp2RYh.jpeg!thumbnail"
          alt="图片"
        />
      </p>
      <p>
        1、录入颤音的时候不建议使用波浪线（目前无法正常显示），可以使用 tr 。
      </p>
      <h2><a name="header-c159" class="md-header-anchor "></a>三、排版</h2>
      <h3><a name="header-c160" class="md-header-anchor "></a>27. 布局</h3>
      <p>1、点击菜单布局-&gt;页面设置；</p>
      <p>2、页面大小选择A4；</p>
      <p>
        3、填入合适的谱表间距（建议为
        1.5mm，如一行所需要包含的小节数太多，可适当缩小）；
      </p>
      <p>4、页边距建议填写 10mm。</p>
      <p>
        <img
          src="https://uploader.shimo.im/f/u0PhYW6i2BE6Kxmb.jpeg!thumbnail"
          alt="图片"
        /><img
          src="https://uploader.shimo.im/f/hLxmLKipEe0mVNku.jpeg!thumbnail"
          alt="图片"
        />
      </p>
      <h3><a name="header-c171" class="md-header-anchor "></a>28. 换行</h3>
      <p>点击任意小节或小节线，按回车（Enter）即可换行。</p>
      <h2><a name="header-c174" class="md-header-anchor "></a>四、上传</h2>
      <h3><a name="header-c175" class="md-header-anchor "></a>29. 检查</h3>
      <p>准备上传前， 要重新打开 mscz 格式的文件查看是否能正常打开。</p>
      <h3>
        <a name="header-c178" class="md-header-anchor "></a>30. 多小节休止
      </h3>
      <p>
        <img
          src="https://uploader.shimo.im/f/CsEPgDseGRYjYqmE.jpeg!thumbnail"
          alt="图片"
        /><img
          src="https://uploader.shimo.im/f/gRYnC4rBVcIzvARO.jpeg!thumbnail"
          alt="图片"
        />
      </p>
      <p>
        遇到好几节休止的情况，需要按两次 “M” 展开再合并后，再导出 musicxml
        文件，否则可能无法正常显示。
      </p>
      <h3><a name="header-c183" class="md-header-anchor "></a>31. 乐器</h3>
      <p>
        上传时须为每个声部选择正确的乐器，否则在客户端查看时，可能无法正常播放。
      </p>
      <h3><a name="header-c186" class="md-header-anchor "></a>32. 上传文件</h3>
      <p>1、Musescore 工程文件 （后缀为 mscz）</p>
      <p>2、用 Musecore导出的 musicxml 文件 （后缀为 xml 或 musicxml）</p>
      <p>
        <img
          src="https://uploader.shimo.im/f/LOSC23JKxOEqtcvt.jpeg!thumbnail"
          alt="图片"
        /><img
          src="https://uploader.shimo.im/f/0rKrJsFFMqQILuji.jpeg!thumbnail"
          alt="图片"
        />
      </p>
      <p></p>
    </div>
  </v-container>
</template>

<script>
export default {
  name: "HandBookMusescore",
  data: function() {
    return {

    };
  }
};
</script>

<style scoped>
      html,
      body {
        overflow-x: initial !important;
      }
      html {
        font-size: 14px;
        background-color: rgb(255, 255, 255);
        color: rgb(51, 51, 51);
      }
      body {
        margin: 0px;
        padding: 0px;
        height: auto;
        bottom: 0px;
        top: 0px;
        left: 0px;
        right: 0px;
        font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
        font-size: 1rem;
        line-height: 1.42857143;
        overflow-x: hidden;
        background-image: inherit;
        background-size: inherit;
        background-attachment: inherit;
        background-origin: inherit;
        background-clip: inherit;
        background-color: inherit;
        background-position: inherit inherit;
        background-repeat: inherit inherit;
      }
      a:active,
      a:hover {
        outline: 0px;
      }
      .in-text-selection,
      ::selection {
        background-color: rgb(181, 214, 252);
        text-shadow: none;
        background-position: initial initial;
        background-repeat: initial initial;
      }
      #write {
        margin: 0px auto;
        height: auto;
        width: inherit;
        word-break: normal;
        word-wrap: break-word;
        position: relative;
        padding-bottom: 70px;
        white-space: pre-wrap;
        overflow-x: auto;
      }
      .for-image #write {
        padding-left: 8px;
        padding-right: 8px;
      }
      body.typora-export {
        padding-left: 30px;
        padding-right: 30px;
      }
      @media screen and (max-width: 500px) {
        body.typora-export {
          padding-left: 0px;
          padding-right: 0px;
        }
        .CodeMirror-sizer {
          margin-left: 0px !important;
        }
        .CodeMirror-gutters {
          display: none !important;
        }
      }
      .typora-export #write {
        margin: 0px auto;
      }
      #write > p:first-child,
      #write > ul:first-child,
      #write > ol:first-child,
      #write > pre:first-child,
      #write > blockquote:first-child,
      #write > div:first-child,
      #write > table:first-child {
        margin-top: 30px;
      }
      #write li > table:first-child {
        margin-top: -20px;
      }
      img {
        max-width: 100%;
        vertical-align: middle;
      }
      input,
      button,
      select,
      textarea {
        color: inherit;
        font-family: inherit;
        font-size: inherit;
        font-style: inherit;
        font-variant-caps: inherit;
        font-weight: inherit;
        font-stretch: inherit;
        line-height: inherit;
      }
      input[type="checkbox"],
      input[type="radio"] {
        line-height: normal;
        padding: 0px;
      }
      ::before,
      ::after,
      * {
        box-sizing: border-box;
      }
      #write p,
      #write h1,
      #write h2,
      #write h3,
      #write h4,
      #write h5,
      #write h6,
      #write div,
      #write pre {
        width: inherit;
      }
      #write p,
      #write h1,
      #write h2,
      #write h3,
      #write h4,
      #write h5,
      #write h6 {
        position: relative;
      }
      h1 {
        font-size: 2rem;
      }
      h2 {
        font-size: 1.8rem;
      }
      h3 {
        font-size: 1.6rem;
      }
      h4 {
        font-size: 1.4rem;
      }
      h5 {
        font-size: 1.2rem;
      }
      h6 {
        font-size: 1rem;
      }
      p {
        margin-block-start: 1rem;
        margin-block-end: 1rem;
        margin-inline-start: 0px;
        margin-inline-end: 0px;
      }
      .mathjax-block {
        margin-top: 0px;
        margin-bottom: 0px;
        margin-block-start: 0rem;
        margin-block-end: 0rem;
      }
      .hidden {
        display: none;
      }
      .md-blockmeta {
        color: rgb(204, 204, 204);
        font-weight: bold;
        font-style: italic;
      }
      a {
        cursor: pointer;
      }
      #write input[type="checkbox"] {
        cursor: pointer;
        width: inherit;
        height: inherit;
        margin: 4px 0px 0px;
      }
      tr {
        break-inside: avoid;
        break-after: auto;
      }
      thead {
        display: table-header-group;
      }
      table {
        border-collapse: collapse;
        border-spacing: 0px;
        width: 100%;
        overflow: auto;
        break-inside: auto;
        text-align: left;
      }
      table.md-table td {
        min-width: 80px;
      }
      .CodeMirror-gutters {
        border-right-width: 0px;
        background-color: inherit;
      }
      .CodeMirror {
        text-align: left;
      }
      .CodeMirror-placeholder {
        opacity: 0.3;
      }
      .CodeMirror pre {
        padding: 0px 4px;
      }
      .CodeMirror-lines {
        padding: 0px;
      }
      div.hr:focus {
        cursor: none;
      }
      pre {
        white-space: pre-wrap;
      }
      .CodeMirror-gutters {
        margin-right: 4px;
      }
      .md-fences {
        font-size: 0.9rem;
        display: block;
        break-inside: avoid;
        text-align: left;
        overflow: visible;
        white-space: pre;
        background-image: inherit;
        background-size: inherit;
        background-attachment: inherit;
        background-origin: inherit;
        background-clip: inherit;
        background-color: inherit;
        position: relative !important;
        background-position: inherit inherit;
        background-repeat: inherit inherit;
      }
      .md-diagram-panel {
        width: 100%;
        margin-top: 10px;
        text-align: center;
        padding-top: 0px;
        padding-bottom: 8px;
        overflow-x: auto;
      }
      .md-fences .CodeMirror.CodeMirror-wrap {
        top: -1.6em;
        margin-bottom: -1.6em;
      }
      .md-fences.mock-cm {
        white-space: pre-wrap;
      }
      .show-fences-line-number .md-fences {
        padding-left: 0px;
      }
      .show-fences-line-number .md-fences.mock-cm {
        padding-left: 40px;
      }
      .footnotes {
        opacity: 0.8;
        font-size: 0.9rem;
        padding-top: 1em;
        padding-bottom: 1em;
      }
      .footnotes + .footnotes {
        margin-top: -1em;
      }
      .md-reset {
        margin: 0px;
        padding: 0px;
        border: 0px;
        outline: 0px;
        vertical-align: top;
        background-color: transparent;
        text-decoration: none;
        text-shadow: none;
        float: none;
        position: static;
        width: auto;
        height: auto;
        white-space: nowrap;
        cursor: inherit;
        line-height: normal;
        font-weight: normal;
        text-align: left;
        box-sizing: content-box;
        direction: ltr;
        background-position: initial initial;
        background-repeat: initial initial;
      }
      li div {
        padding-top: 0px;
      }
      blockquote {
        margin: 1rem 0px;
      }
      li p,
      li .mathjax-block {
        margin: 0.5rem 0px;
      }
      li {
        margin: 0px;
        position: relative;
      }
      blockquote > :last-child {
        margin-bottom: 0px;
      }
      blockquote > :first-child {
        margin-top: 0px;
      }
      .footnotes-area {
        color: rgb(136, 136, 136);
        margin-top: 0.714rem;
        padding-bottom: 0.143rem;
      }
      @media print {
        html,
        body {
          height: 100%;
        }
        .typora-export * {
          -webkit-print-color-adjust: exact;
        }
        h1,
        h2,
        h3,
        h4,
        h5,
        h6 {
          break-after: avoid-page;
          orphans: 2;
        }
        p {
          orphans: 4;
        }
        html.blink-to-pdf {
          font-size: 13px;
        }
        .typora-export #write {
          padding-left: 1cm;
          padding-right: 1cm;
        }
        .typora-export #write::after {
          height: 0px;
        }
        @page {
          margin: 20mm 0mm;
        }
      }
      .footnote-line {
        margin-top: 0.714em;
        font-size: 0.7em;
      }
      a img,
      img a {
        cursor: pointer;
      }
      pre.md-meta-block {
        font-size: 0.8rem;
        min-height: 2.86rem;
        white-space: pre-wrap;
        background-color: rgb(204, 204, 204);
        display: block;
        overflow-x: hidden;
        background-position: initial initial;
        background-repeat: initial initial;
      }
      p .md-image:only-child {
        display: inline-block;
        width: 100%;
        text-align: center;
      }
      #write .MathJax_Display {
        margin: 0.8em 0px 0px;
      }
      .mathjax-block {
        white-space: pre;
        overflow: hidden;
        width: 100%;
      }
      p + .mathjax-block {
        margin-top: -1.143rem;
      }
      .mathjax-block:not(:empty)::after {
        display: none;
      }
      [contenteditable="true"]:active,
      [contenteditable="true"]:focus {
        outline: none;
        box-shadow: none;
      }
      .task-list {
        list-style-type: none;
      }
      .task-list-item {
        position: relative;
        padding-left: 1em;
      }
      .task-list-item input {
        position: absolute;
        top: 0px;
        left: 0px;
      }
      .math {
        font-size: 1rem;
      }
      .md-toc {
        min-height: 3.58rem;
        position: relative;
        font-size: 0.9rem;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px;
      }
      .md-toc-content {
        position: relative;
        margin-left: 0px;
      }
      .md-toc::after,
      .md-toc-content::after {
        display: none;
      }
      .md-toc-item {
        display: block;
        color: rgb(65, 131, 196);
        text-decoration: none;
      }
      .md-toc-inner:hover {
      }
      .md-toc-inner {
        display: inline-block;
        cursor: pointer;
      }
      .md-toc-h1 .md-toc-inner {
        margin-left: 0px;
        font-weight: bold;
      }
      .md-toc-h2 .md-toc-inner {
        margin-left: 2em;
      }
      .md-toc-h3 .md-toc-inner {
        margin-left: 4em;
      }
      .md-toc-h4 .md-toc-inner {
        margin-left: 6em;
      }
      .md-toc-h5 .md-toc-inner {
        margin-left: 8em;
      }
      .md-toc-h6 .md-toc-inner {
        margin-left: 10em;
      }
      @media screen and (max-width: 48em) {
        .md-toc-h3 .md-toc-inner {
          margin-left: 3.5em;
        }
        .md-toc-h4 .md-toc-inner {
          margin-left: 5em;
        }
        .md-toc-h5 .md-toc-inner {
          margin-left: 6.5em;
        }
        .md-toc-h6 .md-toc-inner {
          margin-left: 8em;
        }
      }
      a.md-toc-inner {
        font-size: inherit;
        font-style: inherit;
        font-weight: inherit;
        line-height: inherit;
      }
      .footnote-line a:not(.reversefootnote) {
        color: inherit;
      }
      .md-attr {
        display: none;
      }
      .md-fn-count::after {
        content: ".";
      }
      .md-tag {
        opacity: 0.5;
      }
      .md-comment {
        color: rgb(162, 127, 3);
        opacity: 0.8;
        font-family: monospace;
      }
      code {
        text-align: left;
      }
      h1 .md-tag,
      h2 .md-tag,
      h3 .md-tag,
      h4 .md-tag,
      h5 .md-tag,
      h6 .md-tag {
        font-weight: initial;
        opacity: 0.35;
      }
      a.md-print-anchor {
        border: none !important;
        display: inline-block !important;
        position: absolute !important;
        width: 1px !important;
        right: 0px !important;
        outline: none !important;
        background-color: transparent !important;
        text-shadow: initial !important;
        background-position: initial initial !important;
        background-repeat: initial initial !important;
      }
      .md-inline-math .MathJax_SVG .noError {
        display: none !important;
      }
      .mathjax-block .MathJax_SVG_Display {
        text-align: center;
        margin: 1em 0em;
        position: relative;
        text-indent: 0px;
        max-width: none;
        max-height: none;
        min-height: 0px;
        min-width: 100%;
        width: auto;
        display: block !important;
      }
      .MathJax_SVG_Display,
      .md-inline-math .MathJax_SVG_Display {
        width: auto;
        margin: inherit;
        display: inline-block !important;
      }
      .MathJax_SVG .MJX-monospace {
        font-family: monospace;
      }
      .MathJax_SVG .MJX-sans-serif {
        font-family: sans-serif;
      }
      .MathJax_SVG {
        display: inline;
        font-style: normal;
        font-weight: normal;
        line-height: normal;
        zoom: 90%;
        text-indent: 0px;
        text-align: left;
        text-transform: none;
        letter-spacing: normal;
        word-spacing: normal;
        word-wrap: normal;
        white-space: nowrap;
        float: none;
        direction: ltr;
        max-width: none;
        max-height: none;
        min-width: 0px;
        min-height: 0px;
        border: 0px;
        padding: 0px;
        margin: 0px;
      }
      .MathJax_SVG * {
        transition: none;
      }

      @include-when-export url(http://fonts.googleapis.com/css?family=Open+Sans:400italic,700italic,700,400&subset=latin,latin-ext);

      @font-face {
        font-family: "Open Sans";
        font-style: normal;
        font-weight: normal;
        src: local("Open Sans Regular"),
          url("file:///Users/HuminiOS/Library/Application%20Support/abnerworks.Typora/themes/github/400.woff")
            format("woff");
      }

      @font-face {
        font-family: "Open Sans";
        font-style: italic;
        font-weight: normal;
        src: local("Open Sans Italic"),
          url("file:///Users/HuminiOS/Library/Application%20Support/abnerworks.Typora/themes/github/400i.woff")
            format("woff");
      }

      @font-face {
        font-family: "Open Sans";
        font-style: normal;
        font-weight: bold;
        src: local("Open Sans Bold"),
          url("file:///Users/HuminiOS/Library/Application%20Support/abnerworks.Typora/themes/github/700.woff")
            format("woff");
      }

      @font-face {
        font-family: "Open Sans";
        font-style: italic;
        font-weight: bold;
        src: local("Open Sans Bold Italic"),
          url("file:///Users/HuminiOS/Library/Application%20Support/abnerworks.Typora/themes/github/700i.woff")
            format("woff");
      }

      html {
        font-size: 16px;
      }

      body {
        font-family: "Open Sans", "Clear Sans", "Helvetica Neue", Helvetica,
          Arial, sans-serif;
        color: rgb(51, 51, 51);
        line-height: 1.6;
      }

      #write {
        max-width: 860px;
        margin: 0 auto;
        padding: 20px 30px 40px 30px;
        padding-top: 20px;
        padding-bottom: 100px;
      }
      #write > ul:first-child,
      #write > ol:first-child {
        margin-top: 30px;
      }

      body > *:first-child {
        margin-top: 0 !important;
      }
      body > *:last-child {
        margin-bottom: 0 !important;
      }
      a {
        color: #4183c4;
      }
      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        position: relative;
        margin-top: 1rem;
        margin-bottom: 1rem;
        font-weight: bold;
        line-height: 1.4;
        cursor: text;
      }
      h1:hover a.anchor,
      h2:hover a.anchor,
      h3:hover a.anchor,
      h4:hover a.anchor,
      h5:hover a.anchor,
      h6:hover a.anchor {
        /*background: url("file:///Users/HuminiOS/Library/Application%20Support/images/modules/styleguide/para.png") no-repeat 10px center;*/
        text-decoration: none;
      }
      h1 tt,
      h1 code {
        font-size: inherit;
      }
      h2 tt,
      h2 code {
        font-size: inherit;
      }
      h3 tt,
      h3 code {
        font-size: inherit;
      }
      h4 tt,
      h4 code {
        font-size: inherit;
      }
      h5 tt,
      h5 code {
        font-size: inherit;
      }
      h6 tt,
      h6 code {
        font-size: inherit;
      }
      h1 {
        padding-bottom: 0.3em;
        font-size: 2.25em;
        line-height: 1.2;
        border-bottom: 1px solid #eee;
      }
      h2 {
        padding-bottom: 0.3em;
        font-size: 1.75em;
        line-height: 1.225;
        border-bottom: 1px solid #eee;
      }
      h3 {
        font-size: 1.5em;
        line-height: 1.43;
      }
      h4 {
        font-size: 1.25em;
      }
      h5 {
        font-size: 1em;
      }
      h6 {
        font-size: 1em;
        color: #777;
      }
      p,
      blockquote,
      ul,
      ol,
      dl,
      table {
        margin: 0.8em 0;
      }
      li > ol,
      li > ul {
        margin: 0 0;
      }
      hr {
        height: 4px;
        padding: 0;
        margin: 16px 0;
        background-color: #e7e7e7;
        border: 0 none;
        overflow: hidden;
        box-sizing: content-box;
        border-bottom: 1px solid #ddd;
      }

      body > h2:first-child {
        margin-top: 0;
        padding-top: 0;
      }
      body > h1:first-child {
        margin-top: 0;
        padding-top: 0;
      }
      body > h1:first-child + h2 {
        margin-top: 0;
        padding-top: 0;
      }
      body > h3:first-child,
      body > h4:first-child,
      body > h5:first-child,
      body > h6:first-child {
        margin-top: 0;
        padding-top: 0;
      }
      a:first-child h1,
      a:first-child h2,
      a:first-child h3,
      a:first-child h4,
      a:first-child h5,
      a:first-child h6 {
        margin-top: 0;
        padding-top: 0;
      }
      h1 p,
      h2 p,
      h3 p,
      h4 p,
      h5 p,
      h6 p {
        margin-top: 0;
      }
      li p.first {
        display: inline-block;
      }
      ul,
      ol {
        padding-left: 30px;
      }
      ul:first-child,
      ol:first-child {
        margin-top: 0;
      }
      ul:last-child,
      ol:last-child {
        margin-bottom: 0;
      }
      blockquote {
        border-left: 4px solid #dddddd;
        padding: 0 15px;
        color: #777777;
      }
      blockquote blockquote {
        padding-right: 0;
      }
      table {
        padding: 0;
        word-break: initial;
      }
      table tr {
        border-top: 1px solid #cccccc;
        background-color: white;
        margin: 0;
        padding: 0;
      }
      table tr:nth-child(2n) {
        background-color: #f8f8f8;
      }
      table tr th {
        font-weight: bold;
        border: 1px solid #cccccc;
        text-align: left;
        margin: 0;
        padding: 6px 13px;
      }
      table tr td {
        border: 1px solid #cccccc;
        text-align: left;
        margin: 0;
        padding: 6px 13px;
      }
      table tr th:first-child,
      table tr td:first-child {
        margin-top: 0;
      }
      table tr th:last-child,
      table tr td:last-child {
        margin-bottom: 0;
      }

      .CodeMirror-gutters {
        border-right: 1px solid #ddd;
      }

      .md-fences,
      code,
      tt {
        border: 1px solid #ddd;
        background-color: #f8f8f8;
        border-radius: 3px;
        padding: 0;
        font-family: Consolas, "Liberation Mono", Courier, monospace;
        padding: 2px 4px 0px 4px;
        font-size: 0.9em;
      }

      .md-fences {
        margin-bottom: 15px;
        margin-top: 15px;
        padding: 0.2em 1em;
        padding-top: 8px;
        padding-bottom: 6px;
      }
      .task-list {
        padding-left: 0;
      }

      .task-list-item {
        padding-left: 32px;
      }

      .task-list-item input {
        top: 3px;
        left: 8px;
      }

      @media screen and (min-width: 914px) {
        /*body {
        width: 854px;
        margin: 0 auto;
    }*/
      }
      @media print {
        html {
          font-size: 13px;
        }
        table,
        pre {
          page-break-inside: avoid;
        }
        pre {
          word-wrap: break-word;
        }
      }

      .md-fences {
        background-color: #f8f8f8;
      }
      #write pre.md-meta-block {
        padding: 1rem;
        font-size: 85%;
        line-height: 1.45;
        background-color: #f7f7f7;
        border: 0;
        border-radius: 3px;
        color: #777777;
        margin-top: 0 !important;
      }

      .mathjax-block > .code-tooltip {
        bottom: 0.375rem;
      }

      #write > h3.md-focus:before {
        left: -1.5625rem;
        top: 0.375rem;
      }
      #write > h4.md-focus:before {
        left: -1.5625rem;
        top: 0.285714286rem;
      }
      #write > h5.md-focus:before {
        left: -1.5625rem;
        top: 0.285714286rem;
      }
      #write > h6.md-focus:before {
        left: -1.5625rem;
        top: 0.285714286rem;
      }
      .md-image > .md-meta {
        border: 1px solid #ddd;
        border-radius: 3px;
        font-family: Consolas, "Liberation Mono", Courier, monospace;
        padding: 2px 4px 0px 4px;
        font-size: 0.9em;
        color: inherit;
      }

      .md-tag {
        color: inherit;
      }

      .md-toc {
        margin-top: 20px;
        padding-bottom: 20px;
      }

      #typora-quick-open {
        border: 1px solid #ddd;
        background-color: #f8f8f8;
      }

      #typora-quick-open-item {
        background-color: #fafafa;
        border-color: #fefefe #e5e5e5 #e5e5e5 #eee;
        border-style: solid;
        border-width: 1px;
      }

      #md-notification:before {
        top: 10px;
      }

      /** focus mode */
      .on-focus-mode blockquote {
        border-left-color: rgba(85, 85, 85, 0.12);
      }

      header,
      .context-menu,
      .megamenu-content,
      footer {
        font-family: "Segoe UI", "Arial", sans-serif;
      }
</style>
